const reducer = (state, action) => ({
  ...state,
  currentTrolleyPrice: action.result[0].totals.totalPrice.amount,
  proposedTrolleyPrice: action.result[1].totals.totalPrice.amount,
  currentTrolleyProducts: action.result[0].pricedProducts,
  proposedTrolleyProducts: action.result[1].pricedProducts,
});

export default reducer;
